import React, { useEffect, useRef, useState } from 'react'
import { CompProps } from 'journey-ui'
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
import mapboxgl from '!mapbox-gl'

mapboxgl.accessToken = process.env.NEXT_PUBLIC_MAPBOX_TOKEN

interface Props extends CompProps<'div'>{
  lat: number
  lng: number
}

export const Mapbox: React.FC<Props> = ({ lat: initialLat, lng: initialLng, ...rest }) => {
  const mapContainer = useRef(null)
  const map = useRef(null)
  const [lng, setLng] = useState(initialLng)
  const [lat, setLat] = useState(initialLat)
  const [zoom, setZoom] = useState(9)

  useEffect(() => {
    if (map.current) return // initialize map only once
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [lng, lat],
      zoom,
    })

    const brandMarker = new mapboxgl.Marker()
      .setLngLat([lng, lat])
      .addTo(map.current)
  })

  useEffect(() => {
    if (!map.current) return // wait for map to initialize
    map.current.on('move', () => {
      setLng(map.current.getCenter().lng.toFixed(4))
      setLat(map.current.getCenter().lat.toFixed(4))
      setZoom(map.current.getZoom().toFixed(2))
    })
  })

  return (
    <div {...rest}>
      <div ref={mapContainer} className="map-container" />
    </div>
  )
}
